import { render, staticRenderFns } from "./HallInfo.vue?vue&type=template&id=3a4863e7&scoped=true"
import script from "./HallInfo.vue?vue&type=script&lang=js"
export * from "./HallInfo.vue?vue&type=script&lang=js"
import style0 from "./HallInfo.vue?vue&type=style&index=0&id=3a4863e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4863e7",
  null
  
)

export default component.exports